<template>
  <div>
    <b-modal
      id="modalSelectProduit"
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
      size="xl"
      :title="titleModal"
    >
      <template #default>
        <div class="row mt-n4">
          <div class="col-md-12">
            <div class="card">
              <div class="card-body mt-n2 mb-n2">
                <div class="row mt-n2 d-flex justify-content-center">
                  <div class="col-md-6">
                    <cool-select
                      v-model="selectedArticle"
                      :items="articles"
                      item-text="designation"
                      placeholder="Recherche produit"
                      disable-filtering-by-search
                      @search="onSearchArticle"
                      @select="onSelectedArticle"
                      :search-text.sync="searchText"
                    >
                      <template #no-data>
                        {{
                          noData
                            ? 'Aucun resultat.'
                            : '2 caratères pour lancer la recherche.'
                        }}
                      </template>
                      <template #item="{ item }">
                        <div class="item">
                          <div>
                            <h5>{{ item.designation }}</h5>
                            <span v-if="item.reference" class="d-block">
                              Référence : {{ item.reference }}
                            </span>
                            <span v-if="item.unite" class="d-block">
                              Unité : {{ item.unite }}
                            </span>
                            <span v-if="item.article_type" class="d-block">
                              Type d'article :
                              {{
                                item.article_type === 'produits'
                                  ? 'Produit'
                                  : 'Service'
                              }}
                            </span>
                          </div>
                        </div>
                      </template>
                    </cool-select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template #modal-footer>
        <button
          type="button"
          class="btn btn-danger mr-2"
          @click="$bvModal.hide('modalSelectProduit')"
        >
          Fermer
        </button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import URL_ARTICLE from '@/http/article_stock/article';
import { CoolSelect } from 'vue-cool-select';
export default {
  data() {
    return {
      articles: [],
      selectedArticle: null,
      noData: false,
      timeoutId: null,
      searchText: null,
    };
  },
  components: {
    CoolSelect,
  },
  methods: {
    onSelectedArticle: function (select) {
      if (select) {
        this.$emit('onProduitSelected', {
          uuid: select.uuid,
          resource_uuid: select.resource_uuid,
          designation: select.designation,
          reference: select.reference,
          unite: select.unite,
          stock: select.stock,
          type: select.article_type === 'produits' ? 'Produit' : 'Service',
          nomenclatures: select.nomenclatures,
        });
        this.$bvModal.hide('modalSelectProduit');

        this.searchText = null;
        this.selectedArticle = null;
        this.articles = [];
      }
    },
    async onSearchArticle(search) {
      const lettersLimit = 2;

      this.articles = [];
      this.noData = false;

      if (search.length < lettersLimit) {
        return;
      }

      clearTimeout(this.timeoutId);
      this.timeoutId = setTimeout(async () => {
        await window.axios
          .get(URL_ARTICLE.SEARCH_ARTICLE, {
            params: {
              search: search,
              onlyProduit: true,
              include_nomenclature: true,
              sortBy: 'designation',
              sortDesc: false,
            },
          })
          .then((resp) => {
            this.articles = resp.data;
          })
          .catch();

        if (!this.articles.length) {
          this.noData = true;
        } else if (this.articles.length === 1) {
          this.onSelectedArticle(this.articles[0]);
        }
      }, 500);
    },
    showModal() {
      this.searchText = null;
      this.selectedArticle = this.selectedProduit;
      this.$bvModal.show('modalSelectProduit');
    },
  },
  props: ['selectedProduit', 'titleModal'],
};
</script>

<style scoped lang="scss"></style>
